// extracted by mini-css-extract-plugin
export default {"tradingView":"App_tradingView__7e9oW","logoutBtn":"App_logoutBtn__bTlY9","newOrderBtn":"App_newOrderBtn__1kTQx"};